import React, {useEffect} from 'react';

import MaterialTable from "material-table";

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Typography from "@material-ui/core/Typography/Typography";
import {useDispatch, useSelector} from "react-redux";
import {getLoginLogouts} from "../../../actions/i4Actions";
import {convertISODateTimeToBRLocale} from "../../../common/Util";
import {renderMilisecondsToTimeDuration} from "../../../utils/datetimehelp";


const tableIcons = {
    Add: AddBox,
    Check: Check,
    Clear: Clear,
    Delete: DeleteOutline,
    DetailPanel: ChevronRight,
    Edit: Edit,
    Export: SaveAlt,
    Filter: FilterList,
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
    ResetSearch: Clear,
    Search: Search,
    SortArrow: ArrowUpward,
    ThirdStateCheck: Remove,
    ViewColumn: ViewColumn
};



const LoginLogoutsTabela = (props) => {
    const loginLogouts = useSelector( st => st.i4.loginLogouts);

    const dispatch = useDispatch();

    useEffect( () => {
        dispatch(getLoginLogouts());
    }, []);







    const getColumns = () => {
        return [
            {
                title: 'id',
                field: 'id',
                editable: 'never',
                hidden: true
            },

            {
                title: 'Operador',
                field: 'operadorId',
                editable: 'never',
            },
            {
                title: 'Login',
                field: 'dt',
                render: rowData => {return convertISODateTimeToBRLocale(rowData.dt) },
                editable: 'never',
            },
            {
                title: 'Logout',
                field: 'dtLogout',
                editable: 'never',

                render: rowData => {return convertISODateTimeToBRLocale(rowData.dtLogout) },

            },
            {
                title: 'Horas',
                field: '',
                editable: 'never',
                align: "right",
                render: rowData => {
                    const df = rowData.dtLogout? new Date(rowData.dtLogout).getTime() : new Date().getTime();
                    return renderMilisecondsToTimeDuration(df - new Date(rowData.dt).getTime())
                },

            },





        ];
    }

    const ll = loginLogouts.sort((a, b) => (a.dt > b.dt) ? -1 : 1)

        return (
            <React.Fragment>


                        <MaterialTable
                            icons={tableIcons}
                            title="Logins e Logouts"
                            columns={getColumns()}
                            data={ll}
                            // onRowClick= {(event,  rowData) => {
                            //         props.openDialog(true,rowData);
                            // }}
                            actions={[
                                // {
                                //     icon: 'add',
                                //     tooltip: 'Novo Meta',
                                //     isFreeAction: true,
                                //     onClick: (event) => {
                                //           props.openDialog(true, null);
                                //          }
                                // }
                            ]}

                            options={{
                                filtering: true,
                                pageSize: 15,
                                pageSizeOptions: [10,25,50],
                                addRowPosition: 'first'
                            }}



                        />


            </React.Fragment>
        );

}

export default LoginLogoutsTabela;

